import { cn } from "@/lib/utils"

export default function ModalSubtitle({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <p
      className={cn(
        "text-center text-muted-foreground text-sm mb-8 mt-0.5 max-w-xs mx-auto",
        className
      )}
    >
      {children}
    </p>
  )
}
